export default {
      id: "GripFlexionExtension-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#GripFlexionExtension",
      toString: function () {
        return this.url;
      }
    }